import { BanknotesIcon, MapPinIcon } from '@heroicons/react/24/outline';
import { Button, Chip } from '@mui/material';
import { Link } from 'react-router-dom';
import ProfilePhoto from '../ProfilePhoto';

const UserDetailsCard = ({ userData, location, skills }) => {
  const visibilityLimit = 3;

  const getLocationString = (locationData) => {
    if (!locationData) return null;

    const location = locationData.city || locationData.geo_name;

    const state = locationData.state || locationData.geo_state;

    if (!location) return null;

    // Process the location string
    const processedLocation = location
      .replace(/^Greater\s+/, '') // Remove "Greater" only at the start
      .replace(/\s+Area$/, '') // Remove "Area" only at the end
      .trim();

    return `${processedLocation}${state ? `, ${state}` : ''}`;
  };

  return (
    <div className="p-8 bg-white rounded-lg border border-[#ECEDF2] mb-7">
      <div className="flex space-y-4 flex-col">
        <div className="flex space-x-4">
          <div className="flex justify-center">
            <ProfilePhoto
              photo={userData.photo}
              profile_photo={userData.profile_photo}
              gender={userData.gender}
            />
          </div>
          <div className="flex flex-col justify-center">
            <div className="flex gap-1.5">
              {userData.first_name && (
                <h2 className="text-2xl font-semibold">
                  {userData.first_name}
                </h2>
              )}
              {userData.last_name && (
                <h2 className="text-2xl font-semibold">
                  {userData.last_name.charAt(0).toUpperCase()}
                </h2>
              )}
            </div>
            {userData.title && (
              <h4 className="text-base font-medium">{userData.title}</h4>
            )}
            <div className="flex space-x-5">
              {location && location.length > 0 && (
                <div className="flex items-center">
                  <MapPinIcon className="h-5 w-5 mr-2" />
                  <span className="text-base">
                    {getLocationString(location[0])}
                  </span>
                </div>
              )}
              <div className="flex items-center">
                <BanknotesIcon className="h-5 w-5 mr-2" />
                <span className="text-base">N/A</span>
              </div>
            </div>
          </div>
        </div>
        <div className="flex space-x-3">
          {skills?.length > 0 ? (
            <>
              {skills.slice(0, visibilityLimit).map((skill) => (
                <Chip
                  variant="outlined"
                  key={skill.skill_id}
                  label={skill.skill_name}
                  sx={{
                    mr: 0.5,
                    mt: 0.5,
                  }}
                />
              ))}
              {skills.length > visibilityLimit && (
                <Chip
                  key="more"
                  label={`+${skills.length - visibilityLimit}`}
                  variant="filled"
                  sx={{ mr: 0.5, mt: 0.5 }}
                />
              )}
            </>
          ) : null}
        </div>

        <div>
          {/* <button className="bg-blue-600 px-7 py-2 text-white rounded-xl hover:bg-blue-800">
            Download CV
          </button> */}
          {userData.resumes && userData.resumes.length > 0 && (
            <div className="mt-4 flex space-x-3">
              {userData.resumes.slice(0, visibilityLimit).map((resume) => (
                <Link
                  key={resume.resume_id}
                  to={`https://filmconnx-production.s3.amazonaws.com/uploads/${resume.resume_filename}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button variant="contained" color="primary">
                    {resume.resume_name
                      ? resume.resume_name.charAt(0).toUpperCase() +
                        resume.resume_name.slice(1)
                      : 'Sample Resume'}
                  </Button>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserDetailsCard;
